'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storageProvider = {

    cartCacheKey: 'cartCache',
    previousCartPersistedKey: 'previousCartPersisted',

    setValue: function setValue(key, insertedValue, updateOnly) {
        this.internals.setValueInternal(localStorage, key, insertedValue, updateOnly);
    },

    getValue: function getValue(key) {
        var maxLifeTimeMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

        return this.internals.getValueInternal(localStorage, key, maxLifeTimeMinutes);
    },

    clearValue: function clearValue(key) {
        this.internals.clearValueInternal(key, localStorage);
    },

    setValueSession: function setValueSession(key, insertedValue, updateOnly) {
        this.internals.setValueInternal(sessionStorage, key, insertedValue, updateOnly);
    },

    getValueSession: function getValueSession(key) {
        var maxLifeTimeMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

        return this.internals.getValueInternal(sessionStorage, key, maxLifeTimeMinutes);
    },

    clearValueSession: function clearValueSession(key) {
        this.internals.clearValueInternal(key, sessionStorage);
    },

    internals: {
        setValueInternal: function setValueInternal(typedStorage, key, insertedValue, updateOnly) {
            try {
                if (updateOnly) {
                    var previousValue = this.getValueInternal(typedStorage, key, Number.MAX_VALUE);
                    if (previousValue && previousValue.value) {
                        insertedValue = (0, _extends3.default)({}, previousValue, insertedValue);
                    } else return;
                }

                var storedObject = {
                    value: insertedValue,
                    type: typeof insertedValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(insertedValue),
                    timestamp: new Date().getTime()
                };
                typedStorage.setItem(key, (0, _stringify2.default)(storedObject));
            } catch (e) {
                console.error(e);
            }
        },

        getValueInternal: function getValueInternal(typedStorage, key) {
            var maxLifeTimeMinutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;

            try {
                var obtainedValue = typedStorage.getItem(key);
                if (!obtainedValue) return null;

                var obtainedObject = JSON.parse(obtainedValue);

                var nowUnix = new Date().getTime();
                if (obtainedObject.timestamp + maxLifeTimeMinutes * 60 * 1000 < nowUnix) {
                    typedStorage.removeItem(key);
                    return null;
                }

                switch (obtainedObject.type) {
                    case 'int':
                        return parseInt(obtainedObject.value);
                    case 'float':
                        return parseFloat(obtainedObject.value);
                    case 'array':
                        return (0, _from2.default)(obtainedObject.value);
                    default:
                        return obtainedObject.value;
                }
            } catch (e) {
                console.error(e);
            }
        },

        clearValueInternal: function clearValueInternal(key, typedStorage) {
            typedStorage.removeItem(key);
        }
    },
    sharedKeys: { freeProducts: 'freeProductsKey', deliveryType: 'deliveryTypeKey' }
};

exports.default = storageProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/storageProvider.js
// module id = 74
// module chunks = 0 1 2